import { isUUID } from "./uuid";

import type { Order } from "../models/helpers";

export interface PaginationParams<OrderableColumns> {
  limit: number;
  order: Order;
  page: number;
  search?: string;
  sortBy: OrderableColumns;
}

/**
 * Used in RTK-Query list queries
 * Formats query pagination parameters before sending request
 */
export function preparePaginationParams<OrderableColumns>({
  order,
  search,
  sortBy,
  ...rest
}: PaginationParams<OrderableColumns>) {
  const trimmedSearchValue = search?.trim() ?? "";
  const searchIsUUID = isUUID(trimmedSearchValue);
  const appropriateValue = searchIsUUID
    ? trimmedSearchValue.toLowerCase()
    : trimmedSearchValue;

  const optimizedSearch = searchIsUUID
    ? { id: appropriateValue }
    : { search: appropriateValue };

  return {
    ...(appropriateValue && optimizedSearch),
    [`order[${sortBy}]`]: order,
    ...rest,
  };
}
